export const UPDATE_GLOBAL_MESSAGE = '/RecipientsMessage/*/UpdateGlobalMessage';
export const UPDATE_INDIVIDUAL_MESSAGE = '/RecipientsMessage/*/UpdateIndividualMessage';
export const REMOVE_INDIVIDUAL_MESSAGE = '/RecipientsMessage/*/RemoveIndividualMessage';
export const RECIPIENT_CARD_SELECTED = '/RecipientsMessage/*/RecipientCardSelected';
export const RECIPIENT_FILTER = '/RecipientsMessage/*/RecipientFilter';
export const RECIPIENT_EXITING_PAGE = '/RecipientsMessage/*/RecipientExitingPage';
